export function NotFound() {
  return <div className="p-4">There is nothing here...</div>
}
